import React from "react";
import { Paper, Box } from "@material-ui/core";

import BCLLoading from '../../../common/Loading/BCLLoading';
import { UNITS } from '../../../../constants/common';

export default function InsightsBillAnalysis(props) {
    const maxAmount = props.insightsBillAnalysisData.billAmountIncreased > 0 ? props.insightsBillAnalysisData.billAmountCurrent : props.insightsBillAnalysisData.billAmountPrev;
    return (
        <Paper className="insights-inner-container">
            {props.insightsBillAnalysisData.isBillAnalysisLoading ? <BCLLoading /> : ''}
            
            {props.insightsBillAnalysisData.currentBillingCycle1 && props.insightsBillAnalysisData.currentBillingCycle2 && (
                <div className="insights-bill-analysis-billing-cycle">
                    {props.insightsBillAnalysisData.currentBillingCycle1} - {props.insightsBillAnalysisData.currentBillingCycle2}
                </div>
            )}

            {!props.insightsBillAnalysisData.billAnalysisDataNotAvailable && (
                <div className="insights-bill-analysis-compare-container">
                    <div className="insights-bill-analysis-bar-container bar1">
                        <p>{ UNITS[props.electricCostUnit] }{ props.insightsBillAnalysisData.billAmountPrev }</p>
                        <p>{props.translations["BILL_ANALYSIS.PREVIOUS_BILL_AMOUNT"]}</p>
                        <div className="insights-bill-analysis-bar bar1" style={{height: ( props.insightsBillAnalysisData.billAmountPrev / maxAmount * 220 ) + "px"}} />
                    </div>
                    <div className="insights-bill-analysis-bar-container bar2">
                        <p>{ UNITS[props.electricCostUnit] }{ props.insightsBillAnalysisData.billAmountCurrent }</p>
                        <p>{props.translations["BILL_ANALYSIS.BILL_AMOUNT"]}</p>
                        <div className="insights-bill-analysis-bar bar2" style={{height: ( props.insightsBillAnalysisData.billAmountCurrent / maxAmount * 220 ) + "px"}} />
                    </div>
                    <div className="insights-bill-analysis-arrow arrow-left" onClick={() => props.insightsBillAnalysisData.billAnalysisLeftBoundary ? null : props.changeDataToShowOffset(1)} disabled={props.insightsBillAnalysisData.billAnalysisLeftBoundary} />
                    <div className="insights-bill-analysis-arrow arrow-right" onClick={() => props.insightsBillAnalysisData.billAnalysisRightBoundary ? null : props.changeDataToShowOffset(-1)} disabled={props.insightsBillAnalysisData.billAnalysisRightBoundary} />
                </div>
            )}

            { !props.insightsBillAnalysisData.apiError && (
                <div className="insights-bill-analysis-insights">
                    <Box className="insights-bill-analysis-insights-title">
                        {props.insightsBillAnalysisData.billChangeReasonSummary}
                    </Box>
                    { props.insightsBillAnalysisData.billChangeReasons && props.insightsBillAnalysisData.billChangeReasons.length > 0 && (
                        <Box className="insights-bill-analysis-insights-content">
                            {props.insightsBillAnalysisData.billChangeReasons.map ((item, index) => (
                                <Box className="insights-bill-analysis-insights-item" key={index}>
                                    <p className="insights-bill-analysis-insights-reason">{ item.reason }</p>
                                    <p className="insights-bill-analysis-insights-amount">
                                        <span className={ item.contribution > 0 ? "arrow-up" : "arrow-down" }></span>
                                        { UNITS[props.electricCostUnit] }{ Math.abs(Math.round(item.contribution)) }
                                    </p>
                                </Box>
                            ))}
                            <Box className="insights-bill-analysisi-insights-total">
                                <p className="insights-bill-analysis-insights-reason">{props.translations["BILL_ANALYSIS.TOTAL_DIFFERENCE"]}</p>
                                <p className="insights-bill-analysis-insights-amount">
                                    <span className={ props.insightsBillAnalysisData.billAmountIncreased > 0 ? "arrow-up" : "arrow-down" }></span>
                                    { UNITS[props.electricCostUnit] }{ Math.abs(props.insightsBillAnalysisData.billAmountIncreased) }
                                </p>
                            </Box>
                        </Box>
                    )}
                </div>
            )}

            {props.insightsBillAnalysisData.apiError && (
                <div className="insights-bill-analysis-api-error">
                    {props.translations["USAGE.BILL_ANALYSIS_API_ERROR"]}
                </div>
            )}
        </Paper>
    )
};
